import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-surajpur-chess-tournament',
  templateUrl: './surajpur-chess-tournament.component.html',
  styleUrls: ['./surajpur-chess-tournament.component.scss']
})
export class SurajpurChessTournamentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
